import { apiUrlPrefix } from '../../../config';

const fetchBannedUsers = async (setReports) => {
  try {

    // 1. Get the raw value first
    const bearerToken = localStorage.getItem('accessToken');

    const response = await fetch(`${apiUrlPrefix}Report/getAllBannedUsers`, {
      method: "GET",
      credentials: "include", // Include cookies in the request
      headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${bearerToken}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      setReports(data); // Assuming data is an array of user objects
      return true;
    } else {
      console.error("Failed to fetch users");
      return false;
    }
  } catch (error) {
    console.error("Error fetching users:", error);
  }
};

export default fetchBannedUsers;